<template>
  <div>
    <h2 class="heading-2 mb-4">Ihre Ansprechperson</h2>
    <v-sheet class="contact-box">
      <img
        :src="contactImage"
        width="72px"
        height="72px"
        class="contact-photo"
      />
      <div style="margin-left: 24px">
        <div class="contact-name">Frank Hinzen</div>
        <div class="contact-title">Mitarbeiter</div>
        <div
          style="display: flex; flex-direction: column; align-items: flex-start;"
          class="mt-2"
        >
          <span class="contact-way-label">
            <a href="mailto:frank.hinzen@new-energie.de"
              >frank.hinzen@new-energie.de</a
            >
          </span>
          <span class="contact-way-label mt-2">
            <a href="tel:+4921665586231">+49 2166 558 6231</a>
          </span>
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<script>
export default {
  data: () => ({
    contactImage: require("@/assets/Frank Hinzen.jpg")
  })
};
</script>

<style scoped>
.heading-2 {
  font: normal normal 500 30px/34px "GeometriaMedium";
  letter-spacing: 0.6px;
}
.contact-box {
  width: fit-content;
  padding: 24px;
  margin-bottom: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
}
.contact-photo {
  border-radius: 50%;
  object-fit: cover;
}
.contact-name {
  font-size: 16px;
  font-family: "GeometriaMedium", sans-serif;
}
.contact-title {
  font-size: 14px;
}
.contact-way-label {
  padding: 4px;
  font-size: 14px;
  color: #b40055;
  background: #f8e6ee;
  border-radius: 5px;
  line-height: 24px;
}
</style>
